import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Callout,
    Classes,
    Card,
    Dialog,
    FormGroup,
    HTMLTable,
    InputGroup,
    Intent,
} from '@blueprintjs/core';

import { gettext } from 'utils/text';
import { WaybillShape } from 'shapes/waybills';
import { getFieldErrors } from '../utils/formErrors';

const TransportInvoiceNumberDialog = ({
    isOpen,
    onClose,
    selectedWaybills,
    onConfirm,
    errors,
}) => {
    const [transportInvoiceNumber, setTransportInvoiceNumber] = useState('');
    const handleTransportInvoiceNumberChange = useCallback(event => {
        setTransportInvoiceNumber(event.target.value);
    }, []);
    const fieldErrors = errors ? getFieldErrors(errors) : null;

    return (
        <Dialog
            title={gettext('Update transport invoice nr')}
            isOpen={isOpen}
            onClose={onClose}
        >
            {fieldErrors?.nonFieldErrors ? (
                <Callout intent={Intent.DANGER}>
                    {fieldErrors.nonFieldErrors}
                </Callout>
            ) : null}
            <div className="px-4 pt-3">
                <h5 className="bp3-heading">{gettext('Chosen waybills:')}</h5>
                <Card>
                    <HTMLTable bordered condensed striped className="w-100">
                        <thead>
                            <tr>
                                <th>{gettext('Name')}</th>
                                <th>
                                    {gettext('Transport invoice nr')} (
                                    {gettext('current')})
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedWaybills.map(waybill => (
                                <tr key={waybill.number}>
                                    <td>{waybill.number}</td>
                                    <td>{waybill.transport_invoice_nr}</td>
                                </tr>
                            ))}
                        </tbody>
                    </HTMLTable>
                </Card>
                {fieldErrors?.waybills ? (
                    <p className={`${Classes.TEXT_SMALL} text-danger mt-2`}>
                        {fieldErrors.waybills}
                    </p>
                ) : null}
            </div>
            <div className="px-4 pt-5">
                <FormGroup
                    label={gettext('Transport invoice nr')}
                    labelFor="transport-invoice-nr"
                >
                    <InputGroup
                        id="transport-invoice-nr"
                        onChange={handleTransportInvoiceNumberChange}
                    />
                    {/* eslint-disable camelcase */
                    fieldErrors?.transport_invoice_nr ? (
                        <p className={`${Classes.TEXT_SMALL} text-danger mt-2`}>
                            {fieldErrors.transport_invoice_nr}
                        </p>
                    ) : null
                    /* eslint-enable camelcase */
                    }
                </FormGroup>
                <Button
                    text={gettext('Confirm')}
                    onClick={() => onConfirm(transportInvoiceNumber)}
                />
            </div>
        </Dialog>
    );
};

TransportInvoiceNumberDialog.defaultProps = {
    errors: null,
};

TransportInvoiceNumberDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedWaybills: PropTypes.arrayOf(WaybillShape).isRequired,
    onConfirm: PropTypes.func.isRequired,
    errors: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default TransportInvoiceNumberDialog;
